import React from 'react';
import './style.scss'
import { Translation } from "react-i18next";
import { asset } from '../../../helpers/dom.helper';

class HeaderAbout extends React.PureComponent {

  render() {
    return (
      <Translation ns={['translation', 'about']}>
        {(t) => (
          <div className="header-about" style={{ '--about-bg-header': `url(${asset('/images/about/background-header.webp')})` }}>
            <div className="container">
              <div className="row">
                <div className="col-12 text-center">
                  <div className="cover">
                    <h1>SMART PROPERTY SOLUTION</h1>
                    <h2 dangerouslySetInnerHTML={{ __html: t("about:By implementing Smart AI technology, Silverman not only") }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }

}

export default HeaderAbout;
